import { FC, useState } from 'react'
import { Box, Center, Flex, Heading, Input, Spinner, Text, VStack } from '@chakra-ui/react'
import { useAdminArticlePolls } from '@olagg/api-hooks'
import { ArticlePollType } from '@olagg/db-types'
import Pagination from '@olagg/ui-kit/Pagination'
import { useSearchParams } from 'react-router-dom'
import ArticlePollsTable from './Table'

const ArticlePolls: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [filter, setFilter] = useState({
    page: Number(searchParams.get('page') || 1),
    limit: Number(searchParams.get('limit') || 10),
    slug: searchParams.get('slug') || '',
  })

  const onFilter = ({ name, value }: { name: string, value: any }) => {
    setFilter({ ...filter, [name]: value })

    if (value) searchParams.set(name, value)
    else searchParams.delete(name)
    setSearchParams(searchParams)
  }

  const { page, limit } = filter
  const { data, updateArticlePoll, isLoading } = useAdminArticlePolls(filter)
  const articlePolls = data?.articlePolls
  const count = data?.meta.count

  const toggleActive = (poll: ArticlePollType) =>
    updateArticlePoll(poll.id, { active: !poll.active })

  return (
    <Center w='full' pb={4}>
      <VStack color={'white'} w='full'>
        <Heading my={2}>Encuestas de Novedades</Heading>
        <Text color='gray.400' fontSize='sm' textAlign='center' maxW='680px'>
          Las crea el extractor a partir de los códigos que ya están marcados en el cuerpo del
          artículo: desde acá se revisan y se editan, no se crean. Cualquier edición congela la
          encuesta y el recálculo deja de tocarla — <b>el switch de acá también</b>, y es a
          propósito: si no, el siguiente cambio en el cuerpo del artículo volvería a prenderla.
        </Text>

        <Flex w='full' alignItems='center' gap='5' mt='4' maxW='420px'>
          <Input
            placeholder='Buscar por slug del artículo'
            defaultValue={filter.slug}
            onBlur={e => onFilter({ name: 'slug', value: e.target.value })}
          />
        </Flex>

        {isLoading ? (
          <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600'>
            <Spinner />
          </Box>
        ) : (
          articlePolls && articlePolls.length > 0 ? (
            <ArticlePollsTable articlePolls={articlePolls} toggleActive={toggleActive} />
          ) : (
            <Box height='300px' display='flex' justifyContent='center' alignItems='center' fontWeight='600'>
              <Text>No hay ninguna encuesta todavía</Text>
            </Box>
          )
        )}

        <Pagination
          params={{ limit, page, count }}
          onClick={page => onFilter({ name: 'page', value: String(page + 1) })}
          onLimitChange={val => onFilter({ name: 'limit', value: val })}
          hideLimitInput
        />
      </VStack>
    </Center>
  )
}

export default ArticlePolls
